import React, { useState, useCallback, useEffect } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const stl = {
  lat: 38.6270,
  lng: 90.1994
};

const libraries = ['maps', 'places'];

export const withMapUtils = (BaseComponent) => {
  return (props) => {
    const [map, setMap] = useState(null);
    const [placesService, setPlacesService] = useState(null);
  
    const { isLoaded } = useJsApiLoader({
      id: 'google-map-script',
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries
    });
  
    const onLoad = useCallback(
      function callback(map, point = stl) {
        const newPlacesService = new window.google.maps.places.PlacesService(map);
        setPlacesService(newPlacesService);
      
        setMap(map)
      }, []
    );
  
    const onUnmount = useCallback(function callback() {
      setMap(null)
    }, [])
  
  
    return (
      <BaseComponent
        {...props}
        isGoogleApiLoaded={isLoaded}
        googleMap={map}
        onGoogleMapLoad={onLoad}
        onGoogleMapUnmount={onUnmount}
        placesService={placesService}
      />
    );
  }
};
